import { Check, Search, Share2, ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SERVICES } from "@/data/content";

const ICONS = {
  "google-ads": Search,
  "social-media": Share2,
};

const Services = ({ onSelectService }) => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-20 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-slate-500">
            <span className="h-px w-8 bg-magenta" />
            Servicii
          </div>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900">
            Două servicii.{" "}
            <span className="brand-gradient-text">Făcute bine.</span>
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            Nu facem de toate. Ne specializăm pe canalele care aduc cele mai multe vânzări pentru
            brandurile din România.
          </p>
        </div>

        <div className="mt-12 lg:mt-16 grid md:grid-cols-2 gap-6 lg:gap-8">
          {SERVICES.map((svc, idx) => {
            const Icon = ICONS[svc.id];
            const accentColor = svc.accent === "magenta" ? "#E91E8B" : "#2962FF";
            return (
              <article
                key={svc.id}
                data-testid={`service-card-${svc.id}`}
                className="group relative rounded-3xl border border-slate-200 bg-[#FAFAFA] p-8 lg:p-10 hover:-translate-y-1 hover:shadow-2xl hover:shadow-slate-900/5 transition-all duration-300"
              >
                <div className="flex items-start justify-between">
                  <div
                    className="h-14 w-14 rounded-2xl grid place-items-center text-white shadow-lg"
                    style={{ backgroundColor: accentColor, boxShadow: `0 10px 30px -10px ${accentColor}` }}
                  >
                    <Icon size={26} />
                  </div>
                  <span
                    className="text-xs font-semibold uppercase tracking-wider px-3 py-1 rounded-full"
                    style={{ color: accentColor, backgroundColor: `${accentColor}14` }}
                  >
                    {svc.tag}
                  </span>
                </div>

                <h3 className="font-display mt-6 text-3xl font-bold text-slate-900">
                  {svc.title}
                </h3>
                <p className="mt-3 text-slate-600 leading-relaxed">{svc.description}</p>

                <ul className="mt-6 space-y-3">
                  {svc.bullets.map((b, i) => (
                    <li key={i} className="flex items-start gap-3 text-slate-700">
                      <span
                        className="mt-0.5 h-5 w-5 rounded-full grid place-items-center flex-shrink-0"
                        style={{ backgroundColor: `${accentColor}1A` }}
                      >
                        <Check size={12} style={{ color: accentColor }} strokeWidth={3} />
                      </span>
                      <span className="text-[15px]">{b}</span>
                    </li>
                  ))}
                </ul>

                <div className="mt-8 flex items-center justify-between">
                  <Button
                    data-testid={`service-cta-${svc.id}`}
                    variant="ghost"
                    onClick={() => onSelectService?.(svc.title)}
                    className="rounded-full font-semibold hover:bg-white px-4 group/btn"
                    style={{ color: accentColor }}
                  >
                    Solicită ofertă
                    <ArrowUpRight
                      size={16}
                      className="ml-1 transition-transform group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5"
                    />
                  </Button>
                  <span className="font-display text-6xl font-extrabold text-slate-200 select-none">
                    0{idx + 1}
                  </span>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
